<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        label="選擇日期"
        v-model="dateText"
        prepend-icon="mdi-calendar"
        @click:clear="clear"
        v-bind="attrs"
        v-on="on"
        outlined
        :clearable="clearable"
        :hide-details="hideDetails"
        readonly
        required
        :rules="rules"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="menu = false"
      :first-day-of-week="1"
      color="primary"
      ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    value: [String, Number],
    clearable: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    menu: false,
    date: '',
    dateText: ''
    // rules: [v => !!v || '請選擇日期']
  }),
  created () {
    this.dateText = this.value
    this.date = this.value
  },
  watch: {
    date (val) {
      this.dateText = this.date
      this.$emit('input', val)
    }
  },
  methods: {
    clear () {
      this.date = ''
      this.dateText = ''
    }
  },
  computed: {
    rules () {
      if (this.clearable) return []
      return [v => !!v || '請選擇日期']
    }
  }
}
</script>
